
import { ApiProperty } from '@nestjs/swagger';
export class UserIdRequest {
    @ApiProperty()
    userId: string;
}
